import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {translateConnectionObjectToArray} from 'nutshell-core';

import type {Option} from 'shells/select-picker-generic/types';

import {GraphQLSelect} from './graphql-select';
import GET_SOURCES from './queries/sources.graphql';

const FIRST = 1000;

type Props = {
    onChange: (option: Option) => void;
    selectedId: string | null | undefined;
};

export function GraphQLSelectSources(props: Props) {
    const {data, loading} = useQuery(GET_SOURCES, {
        variables: {
            first: FIRST,
        },
        fetchPolicy: 'cache-and-network',
    });

    const sources = data ? data.sources : null;

    const sourceArray = sources ? translateConnectionObjectToArray(sources) : [];
    const sourceOptions = sourceArray.map((source) => ({
        value: source.id,
        label: source.name,
    }));

    return (
        <GraphQLSelect
            isLoading={loading}
            placeholder='Search sources channels…'
            models={sourceOptions}
            onChange={props.onChange}
            selectedId={props.selectedId}
            labelKey='label'
            valueKey='value'
        />
    );
}
